import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-location',
  templateUrl: './turns-location.component.html',
  styleUrls: ['./turns-location.component.scss']
})
export class TurnsLocationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
